<template>
  <v-main>
    <Navigation extension>
      <template v-slot:extension>
        <v-tabs :value="$route.path" grow>
          <v-tab v-if="clinicUser" to="/settings/phone-permission">是否授權患者手機給醫師</v-tab>
          <v-tab to="/settings/sub-accounts">新增/修改子帳號權限</v-tab>
        </v-tabs>
      </template>
    </Navigation>

    <router-view/>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { mapGetters } from "vuex";

export default {
  name: 'SystemSettingsIndex',

  components: {Navigation},

  computed: {
    ...mapGetters([
      'clinicUser'
    ]),
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
